module.exports = __webpack_public_path__ + "img/bespoke70_22.53625b64.jpg";